import * as React from 'react';
import { Messages } from '../../../gen-src/Localize';
import { OverrideListProps, SelectDropdown, SelectDropdownProps } from './SelectDropdown';

export type MultiselectValueSet = Set<string>;
export type MultiselectDropdownProps = SelectDropdownProps<MultiselectValueSet>;

/**
 * Items are toggled using the ENTER key. (Also the SPACE key when using a plain `List`.)
 * Unlike `SingleSelectDropdown`, the popup is not automatically closed on item selection.
 * The popup can be closed by pressing ESC, or by pressing TAB, or by clicking outside of the popup.
 */
export class MultiselectDropdownWidget extends SelectDropdown<MultiselectValueSet> {
  protected makeListProps(): OverrideListProps {
    return {
      onSelect: this.props.onChange!,
      onSelectAll: this.props.onSelectAll!,
      selectOnEnterKey: true,
      selectedValue: undefined!,
      selectedValues: this.props.value!,
    };
  }

  protected renderButtonContent(): React.ReactNode {
    const { children, list: { props: { items } }, value: selectedValues } = this.props;
    if (!(selectedValues instanceof Set) || selectedValues.size < 1 || children) {
      return children ?? '';
    }

    if (selectedValues.size > 1) {
      return Messages.optionsSelected({ COUNT: selectedValues.size.toString() });
    }

    const selectedValue: string = selectedValues.values().next().value;
    return items.find(item => item.value === selectedValue)?.content ?? selectedValue ?? '';
  }
}
